import { TransactionItemOptionsQuery } from '@/context/services/transaction_items/Detail/TransactionItemDetail.service';
import { useUpdateURLSearchParams } from '@/hooks/useConvertToURLSearchParams';
import { useCallback, useMemo, useState } from 'react';
import { useLocation } from 'react-router-dom';

export const useTransactionItemDetailSearchQueryInitial =
  (): TransactionItemOptionsQuery => {
    const location = useLocation();
    return useMemo(() => {
      const searchParams = new URLSearchParams(location.search);
      return {
        keyword: searchParams.get('keyword') || '',
        is_visible:
          searchParams.get('is_visible') === null ||
          searchParams.get('is_visible') === undefined
            ? undefined
            : searchParams.get('is_visible') === 'true',
        page: Number(searchParams.get('page')) || 1,
        per: Number(searchParams.get('per')) || 25,
      };
    }, [location.search]);
  };

export const useTransactionItemDetailSearchQuery = (
  defaultValues: TransactionItemOptionsQuery
) => {
  const [searchQuery, setSearchQuery] =
    useState<TransactionItemOptionsQuery>(defaultValues);
  const updateSearchParams = useUpdateURLSearchParams();

  const handleSearch = useCallback(
    (query: TransactionItemOptionsQuery) => {
      const page = query?.page || 1;
      const keyword = query?.keyword || '';
      const isVisible = query?.is_visible;

      // Handle page-only updates
      if (Object.keys(query).length === 1 && 'page' in query) {
        const newSearchQuery: TransactionItemOptionsQuery = {
          ...searchQuery,
          page,
        };
        setSearchQuery(newSearchQuery);
        updateSearchParams(newSearchQuery);
        return;
      }

      // Handle full search with filters
      const newSearchQuery: TransactionItemOptionsQuery = {
        ...searchQuery,
        page: 1,
        keyword,
        is_visible: isVisible,
      };
      setSearchQuery(newSearchQuery);
      updateSearchParams(newSearchQuery);
    },
    [searchQuery, updateSearchParams]
  );

  return { searchQuery, handleSearch };
};
